module.exports = __webpack_public_path__ + "img/mingyong81.7d103d65.png";